import React, { ReactNode } from "react";
import { DotLegalCheckbox, DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { LegalEntitySelectorViewModel } from "../LegalEntity.types";
import LegalEntitySelector from "../legalEntitySelector/LegalEntitySelector";
import { Box } from "@mui/material";

export interface ILegalEntitySelectorDialog {
    dialogHeader: string;
    buttonOkText: string;
    setSelectedEntities: (selectedEntities: Array<string>) => void;
    selectedEntities: Array<string>;
    setOkClicked: (searchClicked: boolean) => void;
    legalEntityItems?: Array<LegalEntitySelectorViewModel>;
    isLoading: boolean;
    setShowDialog: (showDialog: boolean) => void;
    allColumns: boolean;
    onGridChange: (gridlength: number | string | null) => void;
    gridLength: number | undefined;
    checkBoxText?: ReactNode;
    onCheckBoxChange: (ischecked: boolean) => void;
    isChecked: boolean;
}

export default function LegalEntitySelectorDialog(props: ILegalEntitySelectorDialog) {
    const dialogClose = () => {
        props.setShowDialog(false);
    };

    const onOkClick = () => {
        props.setOkClicked(true);
        props.setShowDialog(false);
    };

    const GetNumberOfSelectedItems = () => {
        return `${props.buttonOkText} (${props.selectedEntities.length})`;
    };

    return (
        <DotLegalDialog
            header={props.dialogHeader}
            buttonOkText={GetNumberOfSelectedItems()}
            okButtonDisabled={props.selectedEntities.length === 0}
            open
            onDialogClose={dialogClose}
            onOkClick={onOkClick}
            buttonRight
            size={props.allColumns ? "lg" : "md"}
        >
            <Box>
                <LegalEntitySelector
                    gridlength={props.gridLength}
                    onGridChange={(e: any) => props.onGridChange(e)}
                    allColumns={props.allColumns}
                    isLoading={props.isLoading}
                    selectedEntities={props.selectedEntities}
                    legalEntityItems={props.legalEntityItems}
                    setSelectedEntities={props.setSelectedEntities}
                />
                {props.checkBoxText && (
                    <DotLegalCheckbox
                        onChange={props.onCheckBoxChange}
                        margin={{ marginLeft: 2, marginTop: 2, marginBottom: 0, marginRight: 2 }}
                        checked={props.isChecked}
                        label={props.checkBoxText}
                    />
                )}
            </Box>
        </DotLegalDialog>
    );
}
